import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CustomIcon from '@Assets/images/icons';

const RegisterSendView = ({
	requestResults,
}: {
	requestResults: {
		status?: string | undefined;
	};
}) => {
	const { status } = requestResults;
	const intl = useIntl();
	return (
		<>
			<div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
				<div className="text-center mb-4">
					<div className="div mb-4"></div>
					{status === 'success' ? (
						<>
							<CustomIcon icon="checkCircle" className="" />
							<h1 className="text-dark mb-3 mt-5 pt-5">
								{intl.formatMessage({ id: 'AUTH.REGISTER.REGISTERSENDVIEW.1' })}{' '}
							</h1>
							<div className="text-gray-400 fw-bold fs-5 mt-5 ">
								<p>
									{intl.formatMessage({
										id: 'AUTH.REGISTER.REGISTERSENDVIEW.2',
									})}{' '}
								</p>
							</div>
						</>
					) : (
						<>
							<CustomIcon icon="alertSignRed" className="" />

							<h1 className="text-dark mb-3 mt-5 pt-5">
								{intl.formatMessage({ id: 'AUTH.REGISTER.REGISTERSENDVIEW.3' })}{' '}
							</h1>
							<div className="text-gray-400 fw-bold fs-5 mt-5 ">
								<p>
									{intl.formatMessage({
										id: 'AUTH.REGISTER.REGISTERSENDVIEW.4',
									})}
								</p>
							</div>
							<div className="d-flex col-12 flex-wrap justify-content-center pb-lg-0 w-100 mt-3">
								<Link className="w-100" to="/auth/register">
									<button
										type="button"
										className="col-12 btn btn-lg btn-primary fw-bolder me-4 mb-0 mt-4"
									>
										<span className="indicator-label ">
											{intl.formatMessage({
												id: 'AUTH.REGISTER.REGISTERSENDVIEW.5',
											})}
										</span>
									</button>
								</Link>
							</div>
						</>
					)}
				</div>

				<div className="d-flex flex-wrap justify-content-center pb-lg-0">
					<Link to="/auth/login">
						<button type="button" className="btn text-primary fw-bolder">
							{intl.formatMessage({ id: 'AUTH.REGISTER.REGISTERSENDVIEW.6' })}
						</button>
					</Link>{' '}
				</div>
				{/* end::Form group */}
			</div>
		</>
	);
};

export default RegisterSendView;
